import { useEffect, useState } from 'react';
import { WifiOff } from 'lucide-react';

/**
 * App-wide notice while the device is offline. Firestore keeps writes made offline and sends them when
 * the connection returns, so a save started offline shows "Saving..." until then; without this notice
 * that looked like a hang (QA 2026-10-05: profile Save on a phone that lost signal).
 */
export default function OfflineBanner() {
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && navigator.onLine === false);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  if (!offline) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
      className="fixed inset-x-0 bottom-0 z-[200] flex items-center justify-center gap-2 bg-[var(--surface-inverse)] px-4 py-3 text-center text-sm font-medium text-[var(--text-inverse)] shadow-lg"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
      You&apos;re offline. Changes you make will be saved as soon as your connection comes back.
    </div>
  );
}
